import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Virtuoso } from "react-virtuoso";

import StyledHomecare from "./StyledHomecare";
import RemoveHomecareModal from "./modals/RemoveHomecareModal";
import Loader from "../../common/Loader/Loader";
import { App } from "../../../routes/Constants";
import APIVariables from "../../../services/api-variables";
import { handleCatch, isValidTimestamp } from "../../../shared/helpers";
import { errorMessages } from "../../../constants/errorMessages.constants";
import { ReactComponent as Remove } from "../../../assets/icons/remove.svg";
import Axios from "../../../services/Axios";

const HomecareList = () => {
  const [modalIsOpen, setIsModalOpen] = useState(false);
  const [existMoreItems, setExistMoreItems] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedHomecare, setSelectedHomecare] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [items, setItems] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    getHomecares();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addHomecare = () => {
    navigate(App.HOMECARE_ADD);
  };

  const getHomecares = async () => {
    await Axios.get(APIVariables.HCP_HOMECARES)
      .then((res) => {
        const { status, data } = res;

        if (status === 200) {
          setItems(data);
          setIsLoading(false);
          if (!!data.next) {
            setExistMoreItems(res.data.next);
          }
        }
      })
      .catch((error) => {
        handleCatch(error);
      });
  };

  const fetchMoreData = async () => {
    await Axios.get(
      existMoreItems ? existMoreItems : APIVariables.HCP_HOMECARES
    )
      .then((res) => {
        const { status, data } = res;

        if (status === 200) {
          setItems(items.concat(data.results));
          const areMoreMoreItems = !!data.next;
          if (areMoreMoreItems) {
            setExistMoreItems(data.next);
          } else {
            setExistMoreItems(false);
          }
        }
      })
      .catch((error) => {
        handleCatch(error);
      });
  };

  const openModalRemoveHomecare = (e, id) => {
    e.stopPropagation();
    setSelectedHomecare(id);
    setIsModalOpen(true);
  };

  const redirectToEditHomecare = (_, id) => {
    navigate(App.HOMECARE_EDIT_DEFAULT + `${id}`);
  };

  const closeModal = () => {
    setSelectedHomecare("");
    setErrorMessage("");
    setIsModalOpen(false);
  };

  const removeHomecare = async () => {
    setErrorMessage("");
    await Axios.delete(APIVariables.HCP_HOMECARE_DELETE + selectedHomecare)
      .then((res) => {
        const { status } = res;
        if (status === 200) {
          const newItems = items.filter((item) => {
            return item.connected_user_id !== selectedHomecare;
          });
          setItems(newItems);
          closeModal();
        }
      })
      .catch(function (error) {
        const errors = error.response.data;
        if (typeof errors === "string") {
          setErrorMessage([errorMessages.INTERNAL_SERVER_ERROR]);
        } else {
          const errorsArray = [];
          Object.keys(errors).forEach((key) => {
            errorsArray.push(key + " - " + errors[key]);
          });
          setErrorMessage(errorsArray);
        }
      });
  };

  return (
    <StyledHomecare>
      {isLoading ? (
        <Loader />
      ) : (
        <React.Fragment>
          <div className="wrapper-homecare main-max-width">
            <h1 className="h1 mineShaft-color">Connected Homecare</h1>
            <button className="second-button" onClick={addHomecare}>
              Add Homecare
            </button>
          </div>
          <div className="layout mt-4">
            <div className="wrapper-infinitescroll">
              <div className="wrapper-table-infinitescroll">
                <div className="table-wrapper head">
                  <div className="name bold align-center">Homecare Name</div>
                  <div className="position bold align-center">Postcode</div>
                  <div className="registered bold align-center">
                    Reg Valid Until
                  </div>
                  <div className="remove bold align-right">Remove</div>
                </div>
                <Virtuoso
                  endReached={existMoreItems && fetchMoreData}
                  style={{ height: "400px" }}
                  data={items}
                  itemContent={(index) => (
                    <div
                      className="head-table table-wrapper"
                      key={index}
                      onClick={(e) =>
                        redirectToEditHomecare(
                          e,
                          items[index].connected_user_id
                        )
                      }
                    >
                      <div className="name align-center">
                        {items[index].name}
                      </div>
                      <div className="position align-center position-homecare">
                        {items[index].postcode}
                      </div>
                      <div className="registered align-center">
                        {isValidTimestamp(items[index].reg_valid_until)
                          ? moment(items[index].reg_valid_until).format(
                              "DD / MM / YYYY"
                            )
                          : items[index].reg_valid_until}
                      </div>
                      <div className="remove align-right">
                        <Remove
                          onClick={(e) =>
                            openModalRemoveHomecare(
                              e,
                              items[index].connected_user_id
                            )
                          }
                        />
                      </div>
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
          {modalIsOpen && (
            <RemoveHomecareModal
              modalIsOpen={modalIsOpen}
              closeModal={closeModal}
              removeHomecare={removeHomecare}
              errorMessage={errorMessage}
            />
          )}
        </React.Fragment>
      )}
    </StyledHomecare>
  );
};
export default HomecareList;
